import { render } from "./iconmenu.vue?vue&type=template&id=438feed6&scoped=true"
import script from "./iconmenu.vue?vue&type=script&lang=js"
export * from "./iconmenu.vue?vue&type=script&lang=js"

import "./iconmenu.vue?vue&type=style&index=0&id=438feed6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-438feed6"

export default script